"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GaleriaDeAmbiente() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  const images = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/sunset_terrace_view.png",
    caption: "Vista al Atardecer",
    className: "md:col-span-2 md:row-span-2"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/cozy_bar_interior.png",
    caption: "Bar Acogedor",
    className: "md:col-span-2 md:row-span-1"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/outdoor_seating_area.png",
    caption: "Terraza Exterior",
    className: "md:col-span-1 md:row-span-1"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/cocktail_preparation.png",
    caption: "Cócteles Artesanales",
    className: "md:col-span-1 md:row-span-1"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/ambient_lighting_night.png",
    caption: "Ambiente Nocturno",
    className: "md:col-span-1 md:row-span-2"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/panoramic_venue_shot.png",
    caption: "Vista Panorámica",
    className: "md:col-span-2 md:row-span-1"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/intimate_corner_seating.png",
    caption: "Rincón Íntimo",
    className: "md:col-span-1 md:row-span-1"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/sunset_skyline_view.png",
    caption: "Horizonte al Atardecer",
    className: "md:col-span-2 md:row-span-1"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/modern_lounge_area.png",
    caption: "Zona Lounge",
    className: "md:col-span-2 md:row-span-1"
  }];
  return <section id="galería-de-ambiente" className="bg-background py-16 md:py-24" ref={ref}>
      <div className="container mx-auto px-4 md:px-6">
        <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-center mb-4 text-foreground">
          Galería de Ambiente
        </h2>
        <p className="text-center text-muted-foreground mb-12 max-w-2xl mx-auto font-sans">
          Descubre el alma de nuestro espacio a través de cada imagen
        </p>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 auto-rows-[200px]">
          {images.map((image, i) => <div key={i} data-index={i} className={`relative group cursor-pointer overflow-hidden rounded-lg shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${image.className}`} style={{
          animationDelay: `${i * 100}ms`
        }}>
              <div className={`w-full h-full transition-opacity duration-[var(--duration-medium)] ${isVisible ? "animate-fade-in-up" : "opacity-0"}`} style={{
            animationDelay: `${i * 100}ms`
          }}>
                <div className="w-full h-full overflow-hidden">
                  <img src={image.src} alt={image.caption} className="w-full h-full object-cover transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)] group-hover:scale-[1.03]" />
                </div>
                
                {}
                <div className="absolute inset-0 bg-black/60 flex items-center justify-center p-6 opacity-0 group-hover:opacity-100 transition-opacity duration-[var(--duration-medium)] ease-[var(--ease-smooth)]">
                  <p className="text-white font-display text-xl md:text-2xl text-center transform translate-y-4 group-hover:translate-y-0 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-smooth)]">
                    {image.caption}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}